import React from "react";
import Layout from "layout";
import Pricing from "./Pricing";

const PricingPage = () => {
  return (
    <Layout>
      <Pricing />
    </Layout>
  );
};

export default PricingPage;
